<template>
  <div class="d-flex flex-column justify-content-center align-items-center" :key="itemKey">
    <draggable>
      <div v-if="itemType" class="d-flex position-relative item-tree-container px-5 mx-5">
        <div :id="'item_' +  itemType.uuid" :data-parent="parent ? parent.uuid : null" @click="toggleChildren"
             class="draggable-item justify-content-center d-flex flex-column align-items-center border-dashed rounded position-relative  bg-light-primary d-flex" style="width:110px;height:110px">


          <div>
            <i :class="itemType.icon +' fs-3x'" v-if="itemType.icon"></i>
          </div>

          <div class="fw-bolder fs-8 px-2 text-uppercase text-center overflow-auto d-flex align-items-center justify-content-center cursor-pointer"
               style="max-lines: 2;line-clamp: 2;">


            {{ property ? property.name : itemType.name }}
          </div>

          <i class="fad fa-shield-alt fs-2x position-absolute text-primary" style="top:-10px;right:-10px"
             v-if="itemType.className === 'Asset'"></i>
          <i class="fad fa-user-shield fs-2x position-absolute text-primary" style="top:-10px;right:-10px"
             v-if="itemType.className === 'Customer'"></i>
          <i class="fad fa-layer-group fs-2x position-absolute text-primary" style="top:-10px;left:-10px"
             v-if="property && property.type.code ==='OBJECT_GROUP'"></i>
        </div>
      </div>
    </draggable>
    <template v-if="itemType && showChildren">
      <div class="connector flex-grow-1 align-self-stretch d-flex justify-content-center position-relative">
        <svg :id="'connector_' + itemType.uuid" class="flex-grow-1 h-70px w-100"
             style="position: absolute;top:0;left:0">
          <template v-for="(prop,index) in itemType.properties">
            <template v-if="prop.type.code.includes('OBJECT')">
              <g>
                <path :id="'hidden_connect_' + prop.value" :ref="'link' + index" class="path link"/>
                <path :id="'connect_' + prop.value" :ref="'link' + index" class="path link"/>
              </g>
            </template>
          </template>
        </svg>
        <div class="h-70px"></div>
      </div>
      <div class="d-flex justify-content-evenly align-items-start">
        <template v-for="(prop , index ) in itemType.properties">
          <template v-if="prop.type.code.includes('OBJECT') && getItemByUuid(prop.value)">
            <ItemTypeTree :itemType="getItemByUuid(prop.value)" :key="prop.uuid" :itemKey="index" :parent="itemType"
                          :property="prop" :visitedUuids="currentVisited" @link="linkChildren"></ItemTypeTree>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>


<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import Item from "@/entity/Item";
import Property from "@/entity/Property";
import ItemType from "@/entity/ItemType";
import {mapper} from "@/Utils/Mapper";
import ItemManager from '@/views/Income/Avenant/Components/AvenantItemManager.vue';
import ItemProperty from '@/entity/ItemProperty';

@Component({components: {ItemManager}})
export default class ItemTypeTree extends Vue {
  @Prop() itemType!: ItemType
  @Prop() parent?: ItemType
  @Prop() property?: ItemProperty
  @Prop() itemKey: any
  @Prop({default: () => []}) visitedUuids!: string[]
  showChildren = true
  children: Item[] = []

  editions: any[] = []
  createdItem: any = null
  currentProperty: any = null

  isEdit = false

  editItem(item: ItemType, property?: ItemProperty) {
    this.isEdit = true
    this.createdItem = item
    this.currentProperty = property as ItemProperty
    (this.$refs as any).objectManager.show();
  }

  get currentVisited(): string[] {
    return [...this.visitedUuids, this.itemType?.uuid].filter(Boolean)
  }

  isCircular(uuid: string): boolean {
    return this.visitedUuids.includes(uuid)
  }

  getItemByUuid(uuid: string) {
    if (this.isCircular(uuid)) {
      return null
    }
    const it = this.$store.state.comparatorStore.itemTypes.find((i: ItemType) => {
      return i.uuid === uuid
    }) as ItemType;
    if (!it || it.code.toLowerCase() === 'coverage') {
      return null
    }
    return it;
  }

  createItem(property: ItemProperty) {
    const it: ItemType = this.$store.state.comparatorStore.itemTypes.find((i: ItemType) => {
      return i.uuid === property.value
    }) as ItemType;

    this.createdItem = it;
    this.currentProperty = property;
    // this.currentParent = property;
    (this.$refs as any).objectManager.show();
  }

  mounted() {
    this.$emit('link')
    this.searchAndCreateObject()
    this.$addListener(window, 'resize', this.linkChildren);

  }


  searchAndCreateObject(): any {
    // console.log(this.itemType)
    // if(this.itemType && this.itemType.properties){}
    this.itemType.properties.forEach((property: ItemProperty) => {
      if (property.type.code == 'OBJECT') {
        const itemType: ItemType = this.$store.state.comparatorStore.itemTypes.find((i: ItemType) => {
          return i.uuid === property.value
        }) as ItemType;
        // property.children.push(mapper.createItemFromType(itemType))
      }
    })

  }


  saveItem() {
    if (this.isEdit) {
      // Trouver l'index de l'ancien item
      const itemIndex = this.currentProperty.children.findIndex((child: Item) => child.uuid === this.itemType.uuid);

      if (itemIndex !== -1) {
        // Remplacer l'item à l'index trouvé
        this.currentProperty.children[itemIndex] = this.createdItem;
      }
    } else {
      // Si ce n'est pas une édition, on ajoute simplement le nouvel item
      this.currentProperty.children.push(this.createdItem);
    }

    this.isEdit = false;
  }

  removeItem(key: number, item: ItemType) {
    if (this.parent && this.parent.properties[key]) {
      if (this.parent.properties[key].type.code != 'OBJECT') {
        // this.parent.properties[key].children = this.parent.properties[key].children.filter(itemChildren => itemChildren.uuid !== item.uuid);
      }

    }
  }


  findMaxItems(property: Property) {
    const itemType: ItemType = this.$store.state.comparatorStore.itemTypes.find((i: ItemType) => {
      return i.uuid === property.model.value
    }) as ItemType;
  }


  toggleChildren() {
    // this.showChildren = !this.showChildren
  }


  linkChildren() {
    if (this.itemType) {
      const parent: any = document.querySelector("#item_" + this.itemType.uuid);
      const children: any = document.querySelectorAll(".draggable-item[data-parent='" + this.itemType.uuid + "']")
      const svg: any = document.querySelector('#connector_' + this.itemType.uuid)
      if (parent && svg) {
        const parentRect = parent!.getBoundingClientRect();
        const svgRect = svg.getBoundingClientRect();

        const startX = parentRect.left + parentRect.width / 2 - svgRect.left;
        const startY = parentRect.bottom - svgRect.top;

        children.forEach((child: any) => {
          const childRect = child.getBoundingClientRect();
          const endX = childRect.left + childRect.width / 2 - svgRect.left;
          const endY = childRect.top - svgRect.top;
          const uuid = child.id.replace('item_', '')
          let path = document.querySelector("#connector_" + this.itemType.uuid + " #connect_" + uuid)!
          let hiddenPath = document.querySelector("#connector_" + this.itemType.uuid + " #hidden_connect_" + uuid)!
          if (path) {
            const delta1 = 0;
            const delta2 = 30;
            const delta3 = 0;
            const delta4 = 30;
            const controlX1 = startX + delta1;
            const controlY1 = startY + delta2;
            const controlX2 = endX - delta3;
            const controlY2 = endY - delta4;

            const d = `M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`;
            path.setAttribute('d', d);
            path.setAttribute('stroke', 'gainsboro');
            path.setAttribute('stroke-width', '2');
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke-dasharray', '5, 5');

            hiddenPath.setAttribute('d', d);
            hiddenPath.setAttribute('stroke', 'transparent');
            hiddenPath.setAttribute('stroke-width', '20');
            hiddenPath.setAttribute('fill', 'none');

          } else {
            console.log('path ' + "#connector_" + this.itemType.uuid + " #connect_" + uuid + ' not found')
          }

        })
      }
    }
    this.$emit('link')
  }
}
</script>


<style scoped>
path {
  cursor: pointer
}

path:hover + path {
  stroke: red;
}

.item-tree-container > .menu {
  opacity: 0;
  display: flex;
  transition: all .5s ease;
  //transform: translateX(-10px);
}

.item-tree-container:hover > .menu {
  opacity: 1;
  transform: translateX(0);
}
</style>
